import { isRejectedWithValue } from "@reduxjs/toolkit";
import { store } from "../store/store";
import { authSlice as authSlice } from "../store/features/authSlice";

/**
 * Log a warning and show a toast!
 */
export const rtkQueryErrorLogger = (api) => (next) => (action) => {
  // RTK Query uses `createAsyncThunk` from redux-toolkit under the hood, so we're able to utilize these matchers!
  if (isRejectedWithValue(action)) {
    console.log("actionsss.",action);

    if (action.payload?.message == "jwt expired") {
      console.log("change state here");
      store.dispatch(authSlice.actions.logout());
    }
    console.warn("We got a rejected action!");
    //   toast.warn({ title: 'Async error!', message: action.error.data.message })
  }

  return next(action);
};